<template>
    <CNav variant="tabs" role="tablist">
        <CNavItem v-for="(dbName, i) in dbList" :key="i">
            <CNavLink href="javascript:void(0);" :active="tabPaneActiveKey1 === i" @click="() => { tabPaneActiveKey1 = i }">
                {{ dbName }}
            </CNavLink>
        </CNavItem>
    </CNav>
    <CTabContent>
        <CTabPane role="tabpanel" :aria-labelledby="dbName + '-tab'" :visible="tabPaneActiveKey1 === i"
            v-for="(dbName, i) in dbList" :key="i">
            <!-- 二级 tab entrance -->
            <!-- <ColTab :colList="colList[tabName]" :dbName="tabName"></ColTab> -->
            <CNav variant="tabs" role="tablist">
                <CNavItem v-for="(colName, i) in colList[dbName]" :key="i">
                    <CNavLink href="javascript:void(0);" :active="tabPaneActiveKey2 === i"
                        @click="() => { tabPaneActiveKey2 = i }">
                        {{ parseCol[colName] }}
                    </CNavLink>
                </CNavItem>
                <!-- other items -->
                <CNavItem :key="colList[dbName].length">
                    <CNavLink href="javascript:void(0);" :active="tabPaneActiveKey2 === colList[dbName].length"
                        @click="() => { tabPaneActiveKey2 = colList[dbName].length }">
                        其他
                    </CNavLink>
                </CNavItem>
            </CNav>
            <CTabContent>
                <CTabPane role="tabpanel" :aria-labelledby="colName + '-tab'" :visible="tabPaneActiveKey2 === i"
                    v-for="(colName, i) in colList[dbName]" :key="i">
                    <!-- entrance -->
                    <CommonQuery :dbName="dbName" :colName="colName" :colSize="colSize[dbName][colName]"></CommonQuery>
                </CTabPane>
                <!-- other content -->
                <CTabPane role="tabpanel" :aria-labelledby="'other-tab'" :visible="tabPaneActiveKey2 === colList[dbName].length" :key="colList[dbName].length">
                    <OtherQuery :dbName="dbName"></OtherQuery>
                </CTabPane>

            </CTabContent>

        </CTabPane>
    </CTabContent>
</template>
  
<script>
import axios from "@/utils/http"
import { CNav } from '@coreui/vue'
import { CNavItem } from '@coreui/vue'
import { CNavLink } from '@coreui/vue'
import { CTabContent } from '@coreui/vue'
import { CTabPane } from '@coreui/vue'
import CommonQuery from './CommonQuery.vue'
import OtherQuery from './OtherQuery.vue'


export default {
    name: 'BasicGUI',
    components: {
        CNav, CNavItem, CNavLink, CTabContent, CTabPane,
        CommonQuery, OtherQuery
    },
    data() {
        return {
            tabPaneActiveKey1: 0,
            tabPaneActiveKey2: 0,
            parseCol: {
                'actors': '角色',
                'armors': '护甲',
                'classes': '职业',
                'commonEvents': '公共事件',
                'elements': '属性',
                'enemies': '敌人',
                'items': '物品',
                'maps': '地图',
                'skills': '技能',
                'states': '状态',
                'switches': '开关',
                'system': '系统',
                'troops': '敌群',
                'variables': '变量',
                'weapons': '武器',
            },
            dbList: [],
            colList: {},
            colSize: {},
            formRange: {}
        }
    },
    props: [],
    methods: {

    },
    created() {
        // console.log(axios.defaults.baseURL)
        axios.post('/info').then((response) => {
            this.dbList = response.data['dbList'];
            this.colList = response.data['colList'];
            this.colSize = response.data['colSize'];
        })
    }
}
</script>
  
<style></style>
  